import { Bar } from '@ant-design/plots';
import React from 'react';
import ReactDOM from 'react-dom';

const DemoBar = () => {

  const data = [
    { date: '3/31/2017', rate: 1.5 },
    { date: '6/30/2017', rate: 1.6 },
    { date: '9/30/2017', rate: 1.4 },
    { date: '12/31/2017', rate: 1.5 },
    { date: '3/31/2018', rate: 1.3 },
    { date: '6/30/2018', rate: 1.2 },
    { date: '9/30/2018', rate: 1.05 },
    { date: '12/31/2018', rate: 0.9 },
    { date: '3/31/2019', rate: 1.2 },
    { date: '6/30/2019', rate: 1.3 },
    { date: '9/30/2019', rate: 1.4 },
    { date: '12/31/2019', rate: 1.8 },
    { date: '3/31/2020', rate: 1.2 },
    { date: '6/30/2020', rate: 1.1 },
    { date: '9/30/2020', rate: 1.0 },
    { date: '12/31/2020', rate: 0.67 },
    { date: '3/31/2021', rate: 0.9 },
  ];
  const config = {
    data,
    theme: "classicDark",
    height: 300,
    xField: 'date',
    yField: 'rate',
    sort: {
      reverse: true,
    },
    label: {
      text: 'frequency',
      formatter: '.1%',
      style: {
        textAlign: (d) => (+d.frequency > 0.008 ? 'right' : 'start'),
        fill: (d) => (+d.frequency > 0.008 ? '#fff' : '#000'),
        dx: (d) => (+d.frequency > 0.008 ? -5 : 5),
      },
    },
    axis: {
      y: {
        labelFormatter: '.0%',
      },
    },
  };
  return <Bar {...config} />;
};

export default DemoBar;
